<template>
  <el-tag :type="updatedAt | connectDateTimeClassFilter">
    <strong>
      {{ updatedAt | connectDateTimeFilter }}
    </strong>
  </el-tag>
</template>
<script>
import dayjs from 'dayjs';
export default {
  filters: {
    connectDateTimeFilter(datetime) {
      if (!datetime) return '無紀錄';
      return dayjs(datetime).format('YYYY-MM-DD HH:mm:ss');
    },
    connectDateTimeClassFilter(datetime) {
      let datetime_dayjs = dayjs(datetime);
      if (!datetime_dayjs.isValid()) return 'warning';

      return dayjs(datetime).isBefore(dayjs().subtract(1, 'days')) ? 'danger' : 'success';
    },
  },
  props: {
    updatedAt: {},
  },
};
</script>
